import { render } from "./PaymentMethodListItems.vue?vue&type=template&id=560f7221"
import script from "./PaymentMethodListItems.vue?vue&type=script&lang=js"
export * from "./PaymentMethodListItems.vue?vue&type=script&lang=js"

import "./PaymentMethodListItems.vue?vue&type=style&index=0&id=560f7221&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__